import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { LabelProject, PutLabelProject } from 'src/app/interfaces/api/labelProject';
import { ApiService } from 'src/app/services/core/api.service';
import { LocalStorageService } from 'src/app/services/core/local-storage.service';
import { environment } from 'src/environments/environment';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class LabelProjectService {

  collection = "LabelProject";
  collectionPath = "labelProjects";
  labelProjects: LabelProject[] = [];
  labelProjectsSignal: WritableSignal<LabelProject[]> = signal([]);
  apiUrl = environment.API_URL;

  constructor(
    public http: HttpClient,
    private apiService: ApiService,
    private localStorage: LocalStorageService
  ) {
  }


  getLabelProjects(query: QueryParams): Observable<{ labelProjects: LabelProject[]}> {
    if (this.labelProjects.length)
      return of({ labelProjects: this.labelProjects });
    return this.apiService.getCollection(this.collectionPath, "", query)
      .pipe(
        tap(res => {
          let { labelProjects } = res;
          this.labelProjects = labelProjects;
          this.labelProjectsSignal.set(labelProjects);
          this.localStorage.setItem("labelProjects", labelProjects);
        })
      );
  }

  getLabelProjectById(id: string): Observable<LabelProject> {
    return this.apiService.getCollectionItem(this.collectionPath, "", id);
  }

  //---POST---//

  //---PUT---//

  updateLabelProject(data: PutLabelProject): Observable<LabelProject> {
    return this.apiService.updateCollectionItem(this.collectionPath, data);
  }

  //---DELETE---//

}
